export * from './Component';
export type { CommonControllerProps } from './typing';
